<atn-ds-centered-overlay type="wide">
  <div class="atn-space-service-center-modal">
    <atn-ds-widget [title]="titleSg()">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelClickHandler()"
        ></i>
      </div>

      <div class="atn-space-service-center-modal__content">
        <div class="atn-space-service-center-modal__field">
          <atn-ds-text
            label="Name"
            [value]="nameSg()"
            (change)="updateName($event)"
          />
        </div>

        <div class="atn-space-service-center-modal__field">
          <span><b>Allocations</b></span>
          <atn-space-modal-functionalizations
            [functionalizations]="functionalizationsSg()"
            (functionalizationChange)="updateFunctionalization($event)"
          />
        </div>
      </div>

      <div
        class="atn-space-service-center-modal__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button
          (click)="saveClickHandler()"
          [disabled]="!canConfirmSg()"
          [loading]="
            serviceCentersEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal()
          "
          >Save</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </div>
</atn-ds-centered-overlay>
